import { Box } from "@mui/material";
import React, {useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ManageUsers from "./ManageUsers";
import { GetUsers } from "../centralAdminSlice";

const UserAdministration = () => {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const { getUserDataInitially } = centralAdmin;

  useEffect(() => {
    if (getUserDataInitially.length <= 0) {
      dispatch(GetUsers({ method: "Get" }));
    }
  }, []);

  return (
    <Box>
      <ManageUsers />
    </Box>
  );
}

export default UserAdministration